<template>
  <div class="main-content">
    <avue-crud
      :data="tableData"
      :option="option"
      :table-loading="showLoading"
      :page.sync="page"
      @on-load="onLoad"
    >
      <template #header>
        <div>
          <div class="flex flex-wrap align-items marginBottom20">
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width70 textAlignRight"
                >产品名称 :
              </span>
              <div class="width300">
                <el-input
                  v-model="searchData.name"
                  placeholder="请输入"
                  clearable
                  maxlength="50"
                ></el-input>
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10">产品分类 : </span>
              <div class="width300">
                <el-cascader
                  v-model="searchData.classifyId"
                  :options="classifyList"
                  style="width: 400px"
                ></el-cascader>
                <!-- <el-select v-model="searchData.classifyId" clearable>
                  <el-option
                    v-for="item in classifyList"
                    :key="item.id"
                    :value="item.id"
                    :label="item.name"
                  ></el-option>
                </el-select> -->
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <el-button size="medium" type="primary" @click="handleSearch"
                >搜索</el-button
              >
            </div>

            <div class="flex align-items marginRight10 marginBottom10">
              <el-button size="medium" type="info" @click="handleReset"
                >重置</el-button
              >
            </div>

            <div class="flex align-items marginRight10 marginBottom10">
              <el-button
                size="medium"
                type="primary"
                @click="handleCreate('', 'add')"
                >新增</el-button
              >
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <el-button
                size="medium"
                style="
                  background: #f59a23;
                  color: #ffffff;
                  border-color: #f59a23;
                "
                @click="handleSynchronous"
                :loading="synchronousLoading"
                >产品同步</el-button
              >
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <el-button
                size="medium"
                type="warning"
                @click="handleConvertImageUrl"
                :loading="convertLoading"
                >文件地址转换</el-button
              >
            </div>
          </div>
        </div>
      </template>
      <template slot="isHome" slot-scope="{ row }">
        <el-switch
          :value="row.isHome"
          :inactive-value="2"
          :active-value="1"
          @change="handleSwitch($event, row.id)"
        ></el-switch>
      </template>
      <template slot="image" slot-scope="{ row }">
        <el-image
          style="width: 80px; height: 80px"
          :src="row.image"
          :preview-src-list="[row.image]"
        >
        </el-image>
      </template>
      <template slot="menu" slot-scope="{ row }">
        <el-button type="text" size="mini" @click="handleCreate(row, 'view')"
          >详情</el-button
        >
        <el-button type="text" size="mini" @click="handleCreate(row, 'edit')"
          >编辑</el-button
        >
        <el-button
          type="text"
          size="mini"
          @click="handleDelete(row)"
          style="color: #ff001f !important"
          >删除</el-button
        >
      </template>
    </avue-crud>
  </div>
</template>

<script>
import {
  infoSolutionClassify,
  infoProductList,
  infoProductDelete,
  infoProductHomeUpdate,
  infoProductSync,
  infoProductImageUrlConvert,
} from "@/api/info/product";
import { mapGetters } from "vuex";

export default {
  name: "index",
  data() {
    return {
      classifyList: [],
      searchData: {
        name: "",
        classifyId: [],
      },
      page: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      },
      tableData: [], //列表数据
      showLoading: false,
      showLoadingForm: false, //防重提交
      option: {
        title: "",
        titleSize: "h3",
        card: false,
        border: true,
        header: false,
        stripe: false, // 显示斑马纹
        showHeader: true, // 显示表头
        index: true, // 显示索引
        indexLabel: "序号", // 索引文字
        size: "small",
        selection: false, // 显示多选框
        page: true, // 显示分页
        align: "center",
        menuAlign: "center",
        menuType: "text",
        editBtn: false,
        delBtn: false,
        column: [
          {
            label: "产品名称",
            prop: "name",
          },
          {
            label: "主图",
            prop: "image",
          },
          {
            label: "分类",
            prop: "classifyName",
          },
          {
            label: "浏览量",
            prop: "readNum",
          },
          {
            label: "排序",
            prop: "sort",
          },
          {
            label: "首页推荐",
            prop: "isHome",
          },
          {
            label: "创建时间",
            prop: "createTime",
          },
        ],
      },
      dialogVisible: false,

      synchronousLoading: false, //同步
      convertLoading: false, //图片地址转换
      syncTimer: null, // 添加定时器变量
    };
  },
  created() {
    this.getClassifyList();
  },
  methods: {
    //初始化
    onLoad() {
      const newData = {
        // path: this.$route.path,
        // searchData: this.searchData,
        ...this.searchData,
      };
      if (this.searchData.classifyId && this.searchData.classifyId.length > 0) {
        newData.classifyId = this.searchData.classifyId[2];
      }
      this.showLoading = true;
      infoProductList({
        page: this.page.currentPage,
        size: this.page.pageSize,
        ...newData,
      }).then((res) => {
        this.showLoading = false;
        if (res.code === 200) {
          this.tableData = res.data.records;
          this.page.total = res.data.total;
        }
      });
    },
    // 查询
    handleSearch() {
      // console.log('查询')
      this.page.currentPage = 1;
      this.onLoad();
    },
    // 重置
    handleReset() {
      this.searchData = {
        title: "",
      };
      this.page.currentPage = 1;
      this.onLoad();
    },
    // 新增编辑
    handleCreate(row, type) {
      this.$router.push({
        path: "/info/product/create",
        query: {
          id: row.id,
          type: type,
        },
      });
    },
    // 详情
    handleDetails(row) {
      console.log(row, "row");
    },
    // 删除
    handleDelete(row) {
      // console.log('删除',row)
      this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        infoProductDelete(row.id).then((res) => {
          if (res.code === 200) {
            this.$message.success("删除成功!");
            this.onLoad();
          }
        });
      });
    },
    // 重置form
    resetForm() {
      this.form = {
        id: "",
        type: "",
      };
    },

    // 关闭
    handleClose() {
      this.dialogVisible = false;
      setTimeout(() => {
        this.resetForm();
      }, 500);
    },
    //输入
    salaryDianChange(e, t) {
      const value = e.target.value;
      this.form[t] = value;
    },

    // 查询
    handleSearch() {
      // console.log('查询')
      this.page.currentPage = 1;
      this.onLoad();
    },
    // 处理树 ，value label
    convertTreeData(tree, valueKey = "id", labelKey = "name") {
      return tree.map((node) => {
        const newNode = {
          value: node[valueKey],
          label: node[labelKey],
          disabled:
            node.parentId == 0 &&
            (!node.children || (node.children && node.children.length == 0)),
        };
        if (node.children) {
          newNode.children = this.convertTreeData(
            node.children,
            valueKey,
            labelKey
          );
        }
        return newNode;
      });
    },
    //权益分类
    getClassifyList() {
      infoSolutionClassify({}).then((res) => {
        this.showLoading = false;
        if (res.code === 200) {
          this.classifyList = this.convertTreeData(res.data);
        }
      });
    },
    //切换是否显示
    handleSwitch(e, id) {
      infoProductHomeUpdate({
        id: id,
        isHome: e,
      }).then((res) => {
        if (res.code === 200) {
          this.$message.success("操作成功");
        }
        this.onLoad();
      });
    },
    // 同步导入
    handleSynchronous() {
      console.log("同步");
      if (this.synchronousLoading) return;
      this.$confirm("确定同步产品吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        try {
          this.syncTimer = setTimeout(() => {
            this.synchronousLoading = false;
          }, 10000);
          this.synchronousLoading = true;
          infoProductSync({}).then((res) => {
            this.synchronousLoading = false;
            clearTimeout(this.syncTimer); // 清除定时器
            if (res.code === 200) {
              this.page.currentPage = 1;
              this.onLoad();
            }
          });
        } catch (error) {
          this.synchronousLoading = false;
          clearTimeout(this.syncTimer); // 错误时也要清除定时器
        }
      });
    },

    /**
     * 触发非 OSS 图片/文件地址转换为 OSS 地址接口
     * @returns {void}
     */
    handleConvertImageUrl() {
      if (this.convertLoading) return;
      this.$confirm("确定进行文件地址转换（上传为华为云地址）吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.convertLoading = true;
        infoProductImageUrlConvert({})
          .then((res) => {
            this.convertLoading = false;
            if (res.code === 200) {
              this.$message.success(res.msg || "地址转换成功!");
              this.page.currentPage = 1;
              this.onLoad();
            } else {
              this.$message.error(res.msg || "地址转换失败");
            }
          })
          .catch((err) => {
            this.convertLoading = false;
            this.$message.error((err && err.msg) || "转化请求失败");
          });
      });
    },
  },
};
</script>

<style scoped>
.copy {
  cursor: pointer;
  /* width: 60px; */
  margin-left: 15px;
  color: #66b1ff;
}
.tips {
  font-size: 20px;
  line-height: 1;
  margin-bottom: 30px;
}
</style>
